import { Link } from "@/lib/router-compat";
import { useI18n, routes } from "@/i18n";
import logoDark from "@/assets/logo-dark-bg.webp";

const Footer = () => {
  const { locale, t } = useI18n();
  const r = routes[locale];

  const serviceLinks = t.whatWeDo.services.map((s) => ({
    label: s.title,
    path: `/${locale}${r.services}/${s.link}`,
  }));

  const companyLinks = [
    { label: t.nav.about, path: `/${locale}${r.about}` },
    { label: t.nav.approach, path: `/${locale}${r.approach}` },
    { label: t.nav.industries, path: `/${locale}${r.industries}` },
    { label: t.nav.insights, path: `/${locale}${r.insights}` },
    { label: t.nav.contact, path: `/${locale}${r.contact}` },
  ];

  const legalLinks = [
    { label: t.footer.privacy, path: `/${locale}${r.privacy}` },
    { label: t.footer.cookies, path: `/${locale}${r.cookies}` },
    { label: t.footer.terms, path: `/${locale}${r.terms}` },
  ];

  return (
    <footer className="bg-[hsl(226,55%,14%)] text-white/70">
      {/* Accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-accent to-transparent" />
      
      <div className="container py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="space-y-6">
            <img src={logoDark} alt="Stahl Swanson" width={118} height={44} className="h-11 w-auto" />
            <p className="text-sm text-white/60 max-w-xs leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="space-y-1 pt-2">
              {t.globalPresence.offices.map((o) => (
                <p key={o.city} className="text-xs text-white/55">{o.city}{o.country ? `, ${o.country}` : ""}</p>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/60 mb-6">
              {t.footer.services}
            </p>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-white/50 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/60 mb-6">
              {t.footer.company}
            </p>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-white/50 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/60 mb-6">
              {t.footer.legal}
            </p>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-white/50 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5">
          <p className="text-xs text-white/55 text-center tracking-wide">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
